export const dashboard = {
    "programactionByArea": "Programaciones por áreas",
    "programactionByDepartment": "Programaciones por departamentos",
    "kpi": {
      "titles": {
        "activedUnits": "Unidades programadas",
        "programmed": "Programaciones",
        "actionPlan": "Planes de acción"
      },
      "total": "Total",
      "inProgress": "En progreso",
      "noStarted": "No iniciados",
      "finished": "Finalizados",
      "rejected": "Rechazados",
      "expired": "Vencidos",
      "canceled": "Cancelados",
      "programmed": "Programados",
      "toStart": "Por iniciar",
      "noProgrammed": "No programados",
      "inclomplete": "Incompleto"
    },
    "href": {
      "indicators-units": "Unidades programadas",
      "indicators-programations": "Programaciones",
      "indicators-action-plan": "Planes de acción",
      "indicators-progress": "Acciones programadas",
      "divisions": "Cumplimiento de programación semanal",
      "filterDivision": "Filtro de programación semanal",
      "completing-questionnaires": "Nivel de cumplimiento por usuario",
      "folios-areas": "Folios por área",
      "folios-department": "Folios por departamento",
      "folios-indicator": "Indicador de folios",
      "top-results": "Top de resultados",
      "results-tabulator": "Tabulador de resultados",
      "area-histogram": "Histórico de programaciones por área",
      "department-histogram": "Histórico de programaciones por departamento",
      "store-performance": "Desempeño de unidades"
    },
    "data": {
      "year": "Año",
      "month": "Mes",
      "week": "Semana",
      "unitId": "ID",
      "unit": "Unidad",
      "country": "País",
      "state": "Estado",
      "department": "Departamento",
      "city": "Ciudad",
      "city_id": "",
      "zone_id": "",
      "zone": "Zona",
      "class": "Clase",
      "division": "División",
      "division_id": "",
      "cve": "CVE",
      "role": "Rol",
      "role_id": "",
      "userType": "Tipo de usuario",
      "user_type_id": "",
      "curp": "CURP",
      "user": "Usuario",
      "user_id": "",
      "questionnaire": "Cuestionario",
      "qestionnaire_id": "",
      "questionnaire_status": "Estatus del cuestionario",
      "questionnaire_status_id": "",
      "area": "Área",
      "area_id": "",
      "department_id": "",
      "start_date": "Fecha de inicio",
      "start_hour": "Hora de inicio",
      "end_date": "Fecha de fin",
      "end_hour": "Hora de fin",
      "application_time": "Tiempo de aplicación",
      "result": "Resultado"
    },
    "dataSettings": {
      "title": "Reporte de programaciones",
      "title2": "Reporte de programaciones por área y departamento"
    },
    "indicators": {
      "modal": {
        "title": {
          "unit": "Filtrar unidades programadas",
          "programmed": "Filtrar programaciones",
          "actionPlan": "Filtrar planes de acción"
        }
      },
      "titles": {
        "units": "Unidades programadas",
        "programming": "Programaciones",
        "actionPlan": "Planes de acción"
      },
     "completingQuestionnaires": {
        "title": "Nivel de cumplimiento por usuario",
        "lastUpdate": "Última actualización: Semana: ",
        "totalgenerals": "Totales generales",
        "totalPrograming": "Total de programaciones",
        "ownScheduling": "Mis programaciones",
        "user": "Usuario",
        "programing": "Programaciones",
        "noExecuted": "No ejecutado",
        "finished": "Finalizado",
        "result": "Resultado",
        "redirect": "Redirigir",
        "manager": "Gerente",
        "supervisor": "Supervisor",
        "hierarchyUsers": "Usuarios de jerarquías"
     }
    },
    "storePerformance": {
      "title": "Desempeño de unidades",
      "tabs": {
        "performance": "Desempeño de Calificaciones",
        "processStatus": "Estado de Procesos"
      },
      "processStatus": {
        "criticalSections": "Secciones críticas",
        "resultRange": "Rango de resultados ({{min}}% - {{max}}%)",
        "apply": "Aplicar",
        "processPerformance": "Desempeño por proceso",
        "highestToLowest": "Mayor a menor",
        "lowestToHighest": "Menor a mayor",
        "topResults": "Top resultados auditoría 03 2026"
      },
      "results": {
        "questionnaires": "Cuestionarios",
        "units": "Unidades",
        "all": "Todos",
        "search": "Buscar"
      },
      "assignedCompanyLabel": "Compañía asignada",
      "selectedPeriod": "Período seleccionado",
      "configureQuery": "Configurar consulta",
      "queryMode": {
        "oneUnitManyQ": "1 Unidad - varios cuestionarios",
        "manyUnitsOneQ": "Varias unidades - 1 cuestionario",
        "oneUnitOneQ": "1 unidad - 1 cuestionario"
      },
      "company": "Compañía",
      "selectCompany": "Compañía",
      "units": "Unidades",
      "questionnaires": "Cuestionarios",
      "search": "Buscar",
      "selectAll": "Seleccionar todos",
      "selectedCount": "{{count}} unidad(es) seleccionada(s)",
      "selectedCountQuestionnaire": "{{count}} cuestionario(s) seleccionado(s)",
      "selectCompanyFirst": "Seleccione una compañía para cargar los datos",
      "selectAtLeastOneUnit": "Seleccione al menos una unidad",
      "consultResults": "Consultar resultados",
      "consultExecutions": "Consultar ejecuciones",
      "cleanFilters": "Limpiar filtros",
      "download": "Descargar",
      "emptyState": {
        "title": "Sin contenido",
        "description": "Selecciona el modo de consulta, elige los cuestionarios y unidades, luego haz clic en <bold>Consultar resultados</bold> para visualizar el desempeño."
      },
      "loadingResults": "Obteniendo resultados, por favor espere...",
      "noResultsFound": "No se encontraron resultados para la consulta realizada.",
      "updatedAt": "Actualizado a las",
      "downloadNotAvailable": "La descarga no está disponible en este momento.",
      "downloadSuccess": "Descarga completada exitosamente.",
      "error": {
        "loadCompanies": "Error al cargar las compañías.",
        "loadData": "Error al cargar unidades y cuestionarios.",
        "loadFilters": "Error al cargar los filtros.",
        "loadResults": "Error al cargar los resultados. Inténtalo de nuevo.",
        "loadPieChart": "Error al cargar los datos del gráfico circular.",
        "generateFailed": "Error al generar el archivo. Por favor, inténtalo de nuevo.",
        "downloadFailed": "Error al descargar el archivo. Por favor, inténtalo de nuevo."
      },
      "chart": {
        "globalAverage": "Promedio global de la tienda",
        "periodPerformance": "Desempeño en el periodo seleccionado"
      },
      "filter": {
        "title": "Desempeño de unidades",
        "period": "Período",
        "from": "Desde",
        "to": "Hasta",
        "week": "Semanas",
        "year": "Año",
        "filters": "Filtros",
        "division": "División",
        "zone": "Zona",
        "user": "Usuario",
        "role": "Rol",
        "apply": "Agregar filtros",
        "clean": "Limpiar filtros",
        "validation": {
          "toBeforeFrom": "La fecha 'Hasta' no puede ser anterior a la fecha 'Desde'",
          "differentYear": "Ambas fechas deben pertenecer al mismo año",
          "max365Days": "El rango no puede superar los 365 días",
          "maxWeeks": "No puede seleccionar más semanas de las que tiene el año",
          "completeRange": "Debe completar ambas fechas para validar el rango"
        }
      },
      "noDataAlert": {
        "oneQuestionnaire": "No hay información disponible para el cuestionario \"{{name}}\".",
        "multipleQuestionnaires": "No hay información disponible en {{count}} cuestionarios seleccionados.",
        "oneUnit": "No hay información disponible para la unidad \"{{name}}\".",
        "multipleUnits": "No hay información disponible en {{count}} unidades seleccionadas."
      },
      "selectedQuestionnaires": "Cuestionarios seleccionados",
      "availableExecutions": "Ejecuciones disponibles del cuestionario",
      "noDate": "Sin fecha",
      "executionCount": "{{count}} ejecucion(es)",
      "selectedExecutionCount": "{{count}} ejecucion(es) seleccionada(s)",
      "executedTo": "al",
      "executedToTime": "a"
    }
  }